@if (!isTraderEntity) { @if (allowed) {
<p class="header">
  {{ 'enhancedDataServicesApiKey' | translate }}
</p>
<ul>
  @for (apiKey of apiKeys; track trackByApiKey($index, apiKey)) {
  <li>
    <p>{{ apiKey }}</p>
    <button
      mat-icon-button
      [matTooltip]="'enhancedDataServicesCopyApiKeyTooltip' | translate"
      [attr.aria-label]="'enhancedDataServicesCopyApiKey' | translate"
      (click)="handleCopyToClipboardButtonClick(apiKey)"
    >
      <firebird-web-icon
        class="icon"
        name="copy-key"
        width="1.125rem"
        height="1.125rem"
      ></firebird-web-icon>
    </button>
  </li>
  }
</ul>
} @else {
<p>
  {{ 'enhancedDataServicesApiKey' | translate }}
  {{ 'enhancedDataServicesNoApiKey' | translate }}
</p>
} } @else {
<p>{{ 'enhancedDataServicesTraderDataApiKey' | translate }}</p>
}
